import { FileStoreService } from './../../shared/_services/file-store.service';
import { ServerPaginationService } from './../../shared/_services/server-pagination.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { PersonaleStoreService } from './../_service/personale-store.service';
import { Persona } from '../models/persona';
import { Component, OnInit } from '@angular/core';
import {Subject, Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import {Permission} from "../../Login/_guards/Permission";

import {ApiRestService} from "../_service/api-rest.service";

@Component({
  selector: 'app-lista-utenti',
  templateUrl: './lista-utenti.component.html',
  styleUrls: ['./lista-utenti.component.css']
})
export class ListaUtentiComponent implements OnInit {
  private subscriptions: Subscription = new Subscription();
  environment = environment;
  contacts: Persona[] = [];
  contactFilter: Persona[] | null = null;
  selectedContact: Persona | null = null;
  selectedContactCopy: Persona | null | any = null;
  _searchTerm = '';
  orderName = 'asc';
  submittedricerca = false;
  cercaform: FormGroup;
  editable:boolean = false;
  showaddform: boolean = false;
  showAllText: string = "Mostra Eliminati"
  showAllUser: boolean = false;
  /**************************************
        Variabili paginazione
  **************************************/
  page = 1;
  pageSize = 50;
  pagesizeserver = 4 // pagine da precaricare da lserver
  collectionSize = 0; // numero totale di elementi nell'array
  newpagegenerated = 1; // pagina per cui è stata fatta la richiesta al server
  type: string;
  filtri: any = {};
  DropdownSources: any = {};
  AllRoles: Ruolo[];
  SelectedRole: Ruolo;
  N_Elementi: string = "50";

  constructor(
    public personaleStore: PersonaleStoreService,
    private formBuilder: FormBuilder,
    private paginationService: ServerPaginationService,
    private filestore: FileStoreService,
    private route: ActivatedRoute,
    private router: Router,
    public permission: Permission,
    private apiRestService: ApiRestService,
    public campoUtility: CampoUtility
  ) {
    // this.personaleStore.getListaPersonale(new Paginazione(1, this.pagesizeserver * this.pageSize)).subscribe(() => {
      this.subscriptions.add(this.personaleStore.$listaPersonale.subscribe((items) => {
        if (items !== null && items !== undefined) {
          this.contacts = items.data;
          this.contactFilter = this.contacts;
          this.collectionSize = items.data.find(x=> x.ruoliObject.find(y => y.id == "AZ") != undefined) != undefined ? items.total-1 : items.total;
          this.selectedContact = null;
        }
      }))
    this.personaleStore.$listaTuttiRuoliAsObject.subscribe((items) => {
      this.AllRoles = items;
    })
    // })
    this.cercaform = this.formBuilder.group({
      cerca: [''],
      ruolofilter: [''],
      size:[''],
    });
  }
  get f() { return this.cercaform.controls;}

  ngOnInit() {
    this.subscriptions.add(this.personaleStore.$editable.subscribe((items) => this.editable = items));
    this.subscriptions.add(this.personaleStore.$showAddForm.subscribe((items) => this.showaddform = items));
    this.subscriptions.add(this.personaleStore.$showAllUser.subscribe((items) => this.showAllUser = items));
    this.cercaform.controls.size.patchValue(50);
    this.route.params.subscribe(data => {
      this.type= data['type'];
      this.filtri.ruolo = data['type']
      setTimeout(()=>{ this.onSearchInputChange(); }, 200)
    })
    this.setupSearchDebouncer();
  }
  public debouncedInputValue = null;
  private searchDecouncer$: Subject<any> = new Subject();

  public onSearchInputChange(): void {
    this.searchDecouncer$.next(this.filtri);
  }

  private setupSearchDebouncer(): void {
    this.searchDecouncer$.pipe(
      debounceTime(1000),
      //distinctUntilChanged(),
    ).subscribe((term: any) => {
      this.debouncedInputValue = Object.assign({},term);
      this.refreshTable(1, this.debouncedInputValue);
    });
  }

  sizeChanged() {
    this.pageSize = parseInt(this.N_Elementi);
    this.onSearchInputChange()
  }

  Search() {
    this.submittedricerca = true;
    if (this.cercaform.invalid) {
      this.onSearchInputChange()
      return;
    }
    this.orderName = 'asc';
    this.onSearchInputChange()
    this.submittedricerca = false;
  }
  filterByName() {
    if (this.orderName === 'asc')
      this.orderName = 'desc';
    else
      this.orderName = 'asc';
    this.refreshTable(this.newpagegenerated);
  }
  filter(v: string) {
      return this.contacts.filter(x => x.nome.toLowerCase().indexOf(v.toLowerCase()) !== -1);
  }
  editContact(contact: Persona) {
    if(!this.permission.isPermitted('gestione-persone')) return;
    this.filestore.SelectSection('Personale');
    this.selectedContact = contact;
    //this.selectedContactCopy = Object.assign({}, this.selectedContact);
    this.personaleStore.updateEditable(true);
    this.personaleStore.updateShowAddForm(false);
    this.personaleStore.updateSelectedUser(this.selectedContact);
    this.router.navigate([this.route.snapshot.queryParams[' listautenti/dipendente '] ||'listautenti/dipendente',])
  }
  deleteUser(selectedContact) {
    if(confirm("Sicuro di voler eliminare questo elemento dalla lista?")) {
      this.personaleStore.deleteUser(selectedContact);
    }
  }
  renewUser(selectedContact) {
    this.personaleStore.renewUser(selectedContact);
  }
  addContact() {
    try {
      (document.getElementById('rightMenu') as HTMLFormElement).style.width = '300px';
    } catch {
    }
    this.router.navigate([this.route.snapshot.queryParams[' listautenti/dipendente '] ||'listautenti/dipendente',])
    this.personaleStore.updateShowAddForm(true);
    this.personaleStore.updateEditable(false);
    var newPersona = new Persona();
    newPersona.ruoliObject = this.SelectedRole ? [this.SelectedRole]: [];
    this.personaleStore.updateSelectedUser(newPersona);
  }
  showDeletedUser() {
    this.personaleStore.updateShowAllUser(!this.showAllUser);
    this.onSearchInputChange()
    if (this.showAllUser) {
      this.showAllText = "Nascondi eliminati";
    } else {
      this.showAllText = "Mostra eliminati";
    }
  }
  order(campo: any) {

  }

  headShow(campo): boolean {
    if (!campo['filtertype'] && !campo['filternottype'])
      return this.campoUtility.Show(campo, this.filter, false);
    var filterType = !campo['filtertype'] || (!Array.isArray(campo['filtertype']) && (campo['filtertype'] == this.type || campo['filtertype'] == this.filter)) || (Array.isArray(campo['filtertype']) && campo['filtertype']?.some(x => x == this.type || x == this.filter))
    var filternotType = !campo['filternottype'] || (!Array.isArray(campo['filternottype']) && campo['filternottype'] != this.type && campo['filternottype'] != this.filter) || (Array.isArray(campo['filternottype']) && (campo['filternottype']?.every(x => x != this.type && x != this.filter)))
    return filterType && filternotType;
  }
  getPage(page: number) {
    this.page = this.paginationService.paginadellalista(page, this.pagesizeserver);
    const pagetosend = this.paginationService.getPage(page, this.newpagegenerated, this.pagesizeserver);
    if ((pagetosend - 1) % this.pagesizeserver === 0) {
      this.newpagegenerated = page;
      this.refreshTable(pagetosend);
    }
  }
  refreshTable(page: number, filters: any = this.filtri) {
    filters.page = (page - 1) / this.pagesizeserver + 1;
    filters.size = this.pagesizeserver * this.pageSize;
    filters.orderByNome = this.orderName;
    const request = filters;
    this.apiRestService.getListaPersonaleWOAdmin(request, this.showAllUser).subscribe(data=>{
      if (data) {
        this.contacts = data?.data ?? [];
        this.contactFilter = data?.data ?? [];
        this.collectionSize = data?.total ?? 0;
        this.selectedContact = null;
        this.SelectedRole = this.AllRoles.find(x=> x.id == request.ruolo) ?? request.ruolo ? {id:request.ruolo, label: request.ruolo} :undefined;
        
      }
    })

  }

  FilterChange($event: { OnChange: string; Event: any }) {
    this.onSearchInputChange();
  }
}

import { Pipe, PipeTransform } from '@angular/core';
import { environment } from 'src/environments/environment';
import {Ruolo} from "../models/Ruolo";
import {debounceTime, delay} from "rxjs/operators";
import { CampoUtility } from 'src/app/shared/models/campo-aggiuntivo';

@Pipe({
  name: 'noAdminFilter',
  pure: false
})
export class noAdminFilter implements PipeTransform {
  transform(items: any[], filter: Object): any {
    if (!items) {return items;}
    return items?.filter(x=> x.ruoliObject.find(y => y.id == "AZ") == undefined);
  }
}










































